import React, { Component } from 'react';
import NotificationCreator from '../notification-creator/notification-creator';
import * as microsoftTeams from "@microsoft/teams-js";
import { connect } from 'react-redux';
import { setNotificationMessage, createNotification,editNotification ,getNotifications} from '../../../actions/notification.actions';
import { Header, Icon, Segment } from 'semantic-ui-react';
import { CONFIG } from '../../../helper/config';
import { storeSessionId } from '../../../actions/view.actions';
import _ from 'lodash';
import { GetNotificationRequiredInfo, NotificationModal } from '../../../modal/notification';

interface IProps {
    notification_msg: string;
    is_license_expire: boolean;
    notify_me_from_inside?: boolean;
    sessionId:string;
    editNotification: (arg0: number, arg1: any, auth_token: string,arg2:string) => void;
    getNotifications: (arg0: GetNotificationRequiredInfo, auth_token: string, is_loader?: boolean) => void;
    storeSessionId:(arg:string) => void;
    team_context?:any;
    notifications:any;
}

interface IState {
    is_submit: boolean;
    auth_token: string;
    teams_context: any;
    selected_notification:any;
}

/**
 * EditNotification component allows users to edit existing notifications.
 * It integrates with Microsoft Teams to fetch context and authentication tokens.
 * The component handles both Teams and WebApp environments.
 * It uses Redux for state management and dispatches actions to update notifications.   
 * @component
 * @example
 * <EditNotification notify_me_from_inside={true} />   
 * 
 */
export class EditNotification extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            is_submit: false,
            auth_token: '',
            teams_context: {},
            selected_notification:{}
        }
    }

    /**
     * Called when the component has been mounted.
     * Handles the logic for both Teams and WebApp.
     * For Teams:
     * - Initializes the Microsoft Teams app.
     * - Gets the context (channel, team, user, etc.).
     * - Gets the auth token.
     * - Calls the getNotifications action with the context and token.
     * - Sets the component state.
     * For WebApp:
     * - Listens for the message event.
     * - Parses the query parameters.
     * - Calls the getNotifications action with the context and token.
     * - Sets the component state.
     */
    componentDidMount() {
        const query_params = window.location.search.split('?')[1];
        const isWebApp = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5]:"";
        const port_no: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0] : '';
        const file_name: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[1] : '';
        const notification_id: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[6] : '';
        console.log('port No', port_no);
        console.log('File Name', file_name);
        console.log("notification_id :: ", notification_id);
        if(isWebApp!==CONFIG.WEBAPP){
        let teams_context: any = {};
        if (!this.props.notify_me_from_inside) {
            microsoftTeams.app.initialize();
            microsoftTeams.app.notifySuccess();
        }
        let comp_ref = this;
        microsoftTeams.app.getContext().then((context) => {
            console.log("context", context);
            teams_context.chatId = (context.chat?.id && context.chat.id !== '') ? context.chat.id : '';
            teams_context.channelId = (context.channel?.id && context.channel.id !== '') ? context.channel.id : '';
            teams_context.groupId = context.team?.groupId;
            teams_context.userObjectId = context.user?.id;
            teams_context.meetingId = context.meeting?.id;
            teams_context.tid = context.user?.tenant?.id;
            teams_context.teams_channel_id = context.channel?.id;
            microsoftTeams.authentication.getAuthToken().then((token: string) => {
                    let info:any = {
                        "va_id": query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
                        "user_id": context.user?.id,
                        "tenant_id": context.user?.tenant?.id,
                        "file_name": file_name,
                        "channelId": "msteams",
                        "notification_id": notification_id,
                        "destination_id":this.getDestinationID(teams_context),
                      }
                    this.props.getNotifications(info, token);
                    comp_ref.setState({ teams_context: teams_context, auth_token: token });
                    if(!this.props.sessionId){
                        let session_id = new Date().toString();
                          this.props.storeSessionId(session_id)
                    }
                }).catch((error) => {
                    console.error("error", error);
                    comp_ref.setState({ is_submit: true });
            })
        }).catch((error) => {
            console.error("error", error);
            comp_ref.setState({ is_submit: true });
        })
    }else{
        let webAppData;
        const handleMessage = (event) => {
            if (event.origin !== event?.data?.parentUrl) return;
            webAppData = { ...event.data };
        
            const token = webAppData.token
            const info:any = {
              "va_id": query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
              "port_no": port_no,
              "user_id": webAppData.aad_object_id,
              "user_name": webAppData.email,
              "tenant_id": webAppData.tenantId,
              "file_name": file_name,
              "channelId": "msteams",
              "notification_id": notification_id,
            }
            this.setState({
              auth_token: token,
              teams_context:info
            })
            this.props.getNotifications(info, token);
            let session_id = new Date().toString();
            this.props.storeSessionId(session_id)
        };
        window.addEventListener('message', handleMessage);
      } 
    }


    /**
     * Called when the component's props or state has changed.
     *
     * If the `notifications` prop has changed, it updates the component's state
     * with the first notification in the `notifications` array.
     * @param prevProps The previous props of the component.
     * @param prevState The previous state of the component.
     * @param snapshot The snapshot of the component.
     */
    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
        if (prevProps.notifications !== this.props.notifications) {
            const newSelectedNotification = this.props.notifications[0];
            if (!_.isEqual(newSelectedNotification, this.state.selected_notification)) {
                this.setState({ selected_notification: newSelectedNotification });
            }
        }
    }

    /**
     * Determines the destination ID for notifications based on the Teams context.
     *
     * @param teams_context - The Microsoft Teams context object.
     * @returns {string} The destination ID:
     * - `chatId` if in a meeting (group scope).
     * - `groupId` if in a channel (team scope).
     * - `userObjectId` if in personal scope.
     */
    getDestinationID = (teams_context: any) => {
        let destination_id = '';
        if (teams_context.meetingId) {
          //group scope
          destination_id = teams_context.chatId;
        }
        else if (teams_context.teams_channel_id) {
          //team scope
          destination_id = teams_context.groupId;
        } else {
          //personal scope
          destination_id = teams_context.userObjectId;
        }
        return destination_id;
      }

    /**
     * Updates the status of a given notification.
     *
     * Merges the notification with context information (tenant, team, channel, user).
     * Dispatches the `editNotification` Redux action.
     * Marks the component state as submitted.
     *
     * @param notification - The notification object to update.
     */
    updateNotificationStatus = (notification: NotificationModal) => {
        let { teams_context } = this.state;
        let status = {
          tenant_id: teams_context.tid || teams_context.tenant_id,
          team_id: (teams_context.groupId) ? teams_context.groupId : '',
          channelId: teams_context.channelId,
          user_id: teams_context.userObjectId || teams_context.user_id,
          platform: notification.description ?? "teams"
        };
        notification={...notification,...status}
        this.props.editNotification(notification.id, notification, this.state.auth_token,"edit-notification");
        this.setState({ is_submit: true })
      };

    /**
     * Renders the component.
     * If the license has expired, it shows a message.
     * If the notification message is success and is_submit is true, it shows a success icon.
     * If the notification message is not empty and not success, it shows an error icon and the message.
     * Otherwise, it shows the NotificationCreator component.
     * @returns {JSX.Element} The rendered component.
     * */
    render() {
        const { notification_msg } = this.props;
        const { is_submit, teams_context,selected_notification } = this.state;
        if (this.props.is_license_expire) {
            return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
        } else if (notification_msg === CONFIG.NOTIFICATION.SUCCESS && is_submit) {
            return <Segment className='notification-sucess-segment' placeholder textAlign='center' >
                <Icon name='check circle' size='massive' color='green' />
            </Segment>
        } else if (notification_msg.trim() !== '' && notification_msg !== CONFIG.NOTIFICATION.SUCCESS ) {
            return <Segment className='notification-sucess-segment' placeholder textAlign='center' >
                <Icon name='times circle' size='massive' color='red' />
                <Header as='h4' content={notification_msg} />
            </Segment>
        } else {
            return (<>
                {( is_submit || selected_notification===undefined ||Object.keys(selected_notification).length === 0 ) ? null : <NotificationCreator teams_context={Object.keys(teams_context).length>0 ? teams_context:this.props.team_context}
                    is_create_notification={false} 
                    saveNotification={this.updateNotificationStatus} notification={selected_notification} /> 
                }
            </>);
        }
    }
}

const mapStateToProps = (state: any) => ({
    notification_msg: state.notificationState.notification_msg,
    is_license_expire: state.viewState.is_license_expire,
    teams_default_view: state.cardLibraryState.teams_default_view,
    sessionId:state.viewState.sessionId,
    notifications: JSON.parse(JSON.stringify(state.notificationState.notifications)),
});

export default connect(mapStateToProps, { setNotificationMessage, createNotification,storeSessionId,editNotification,getNotifications })(EditNotification);